<template>
  <div class="d-flex flex-wrap uni-max-sm my-5">
    <div
      class="modal fade"
      id="area-select"
      tabindex="-1"
      role="dialog"
      aria-labelledby="areaSelectModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <transition name="fade" mode="out-in">
          <div key="1" v-if="step == 1" class="modal-content area-modal">
            <button
              v-for="(u, i) in states"
              class="area-modal-btn is-state"
              :key="i"
              @click="cur_state = u"
            >
              {{ u.toLowerCase() }}
              <div
                v-if="!arealoaded && cur_state == u"
                class="spinner-border text-secondary spinner-border-sm ml-3"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
              <span class="float-right">
                <svg
                  width="9"
                  height="12"
                  viewBox="0 0 9 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 6L4.64275e-07 11.1962L9.18537e-07 0.803847L9 6Z"
                    fill="#C4C4C4"
                  />
                </svg>
              </span>
            </button>
          </div>
          <div key="2" v-if="step == 2" class="modal-content area-modal">
            <div class="action-bar">
              <button @click="step = 1" class="area-modal-btn">
                &lt; &nbsp; Back
              </button>
              <button v-if="selected_areas.length > 0" class="confirm-btn" data-dismiss="modal">
                Confirm
              </button>
            </div>
            <button
              v-for="(u, i) in areas"
              class="area-modal-btn"
              :key="i"
              @click="updateSelectedArea(u)"
            >
              {{ u.toLowerCase() }}
              <span
                class="prop-radio-label-d-before float-right"
                :class="{ lactive: selected_areas.includes(u) }"
              ></span>
            </button>
          </div>
        </transition>
      </div>
    </div>
    <form @submit="submit" class="form-container-contact">
      <div class="header-wrapper">
        <h4 class="text-white">Effortless Property Matching: Discover Your Ideal Properties with Ease</h4>
        <p v-if="!with_signup" class="mb-6">
          Exhausted from relentless property searches? Finding your dream property should be easy. Say goodbye to frustration and simplify your quest. Utilize our automated property matching system, effortlessly inputting your requirements and preferences. It swiftly identifies and emails you the perfect rental or sale options tailored to your needs. No more endless scrolling; streamline your property search today. Your ideal property is within reach.
        </p>
      </div>
      <div v-if="with_signup" class="row">
        <div class="col-md-2 label-col">
          <label class="text-white text-lg mt-2">Account info <span class="text-required">*</span></label>
        </div>
        <div class="col-md-9">
          <div class="row">
            <div class="col-md-6 mb-4">
              <label for="name">Name</label>
              <input type="text" v-model="name" id="name" required />
            </div>
            <div class="col-md-6 mb-4">
              <label for="phone_number">Phone number</label>
              <input type="number" v-model="phone_number" id="phone_number" required />
            </div>
            <div class="col-md-6 mb-4">
              <label for="email">Email</label>
              <input type="email" v-model="email" id="email"  required/>
            </div>
            <div class="col-md-6 mb-4">
              <label for="password">Password</label>
              <input type="password" v-model="password" id="password" required />
            </div>
          </div>
        </div>
      </div>
      <div class="row extra-space">
        <div class="col-md-2 label-col">
          <label class="text-white text-lg mt-2"
            >Listing detail<span class="text-required">*</span>
          </label>
        </div>
        <div class="col-md-9">
          <div class="row mb-2">
            <div class="col-md-3">
              <label
                :class="`btn checkbox-label ${
                  listing_type == 'SALE' ? 'active' : ''
                }`"
              >
                <input
                  type="radio"
                  value="SALE"
                  name="listing_type"
                  v-model="listing_type"
                  class="sale-checkbox-input"
                />
                Sale
              </label>
            </div>
            <div class="col-md-3">
              <label
                :class="`btn checkbox-label ${
                  listing_type == 'RENT' ? 'active' : ''
                }`"
              >
                <input
                  type="radio"
                  value="RENT"
                  name="listing_type"
                  v-model="listing_type"
                  class="sale-checkbox-input"
                />
                Rent
              </label>
            </div>
            <div class="col-12">
              <select v-model="listing_type" class="contact-select" required>
                <option value="SALE">Sale</option>
                <option value="RENT">Rent</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label
                :class="`btn checkbox-label ${
                  category == 'RESIDENTIAL' ? 'active' : ''
                }`"
              >
                <input
                  type="radio"
                  value="RESIDENTIAL"
                  name="category"
                  v-model="category"
                  class="sale-checkbox-input"
                />
                Residential
              </label>
            </div>
            <div class="col-md-3">
              <label
                :class="`btn checkbox-label ${
                  category == 'COMMERCIAL' ? 'active' : ''
                }`"
              >
                <input
                  type="radio"
                  value="COMMERCIAL"
                  name="category"
                  v-model="category"
                  class="sale-checkbox-input"
                />
                Commercial
              </label>
            </div>
            <div class="col-md-3">
              <label
                :class="`btn checkbox-label ${
                  category == 'INDUSTRIAL' ? 'active' : ''
                }`"
              >
                <input
                  type="radio"
                  value="INDUSTRIAL"
                  name="category"
                  v-model="category"
                  class="sale-checkbox-input"
                />
                Industrial
              </label>
            </div>
            <div class="col-md-3">
              <label
                :class="`btn checkbox-label ${
                  category == 'LAND' ? 'active' : ''
                }`"
              >
                <input
                  type="radio"
                  value="LAND"
                  name="category"
                  v-model="category"
                  class="sale-checkbox-input"
                />
                Land
              </label>
            </div>
            <div class="col-12">
              <select v-model="category" class="contact-select" required>
                <option value="RESIDENTIAL">Residential</option>
                <option value="COMMERCIAL">Commercial</option>
                <option value="INDUSTRIAL">Industrial</option>
                <option value="LAND">Land</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="row extra-space">
        <div class="col-md-2 label-col">
          <label class="text-white text-lg mt-2">Property Type: </label>
        </div>
        <div class="col-md-9">
          <div class="row">
            <div class="col-md-3">
              <label
                :class="`btn checkbox-label ${
                  property_sub_type == 'Terrace' ? 'active' : ''
                }`"
              >
                <input
                  type="radio"
                  value="Terrace"
                  name="property_sub_type"
                  v-model="property_sub_type"
                  class="sale-checkbox-input"
                />
                Terrace
              </label>
            </div>
            <div class="col-md-3">
              <label
                :class="`btn checkbox-label ${
                  property_sub_type == 'Semi Detached' ? 'active' : ''
                }`"
              >
                <input
                  type="radio"
                  value="Semi Detached"
                  name="property_sub_type"
                  v-model="property_sub_type"
                  class="sale-checkbox-input"
                />
                Semi Detached
              </label>
            </div>
            <div class="col-md-3">
              <label
                :class="`btn checkbox-label ${
                  property_sub_type == 'Detached' ? 'active' : ''
                }`"
              >
                <input
                  type="radio"
                  value="Detached"
                  name="property_sub_type"
                  v-model="property_sub_type"
                  class="sale-checkbox-input"
                />
                Detached
              </label>
            </div>
            <div class="col-md-3">
              <label
                :class="`btn checkbox-label ${
                  property_sub_type == 'Highrise' ? 'active' : ''
                }`"
              >
                <input
                  type="radio"
                  value="Highrise"
                  name="property_sub_type"
                  v-model="property_sub_type"
                  class="sale-checkbox-input"
                />
                Highrise
              </label>
            </div>
            <div class="col-12">
              <select v-model="property_sub_type" class="contact-select">
                <option :value="null">Select property type</option>
                <option value="Terrace">Terrace</option>
                <option value="Semi Detached">Semi Detached</option>
                <option value="Detached">Detached</option>
                <option value="Highrise">Highrise</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="row extra-space">
        <div class="col-md-2 label-col">
          <label class="text-white text-lg mt-2"
            >Location <span class="text-required">*</span>
          </label>
        </div>
        <div class="col-md-9">
          <div class="row">
            <div class="col-md-12 mb-4">
              <button
                class="filter-location filter-select-icon text-capitalize text-left w-100"
                data-toggle="modal"
                data-target="#area-select"
                type="button"
              >
                <span>Select multiple location / area</span>
              </button>
            </div>
            <div class="col-md-6 mb-4">
              <span v-if="selected_areas.length > 0">Interested in: </span>
              <span v-for="(area, key) in selected_areas" :key="key">
                {{ area }}{{ key + 1 != selected_areas.length ? ", " : "" }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 label-col">
          <label class="text-white text-lg mt-2">Budget </label>
        </div>
        <div class="col-md-9">
          <div class="row">
            <div class="col-md-6 mb-4">
              <label for="min_budget">Minimum budget</label>
              <input type="number" v-model="min_price" id="min_budget" />
            </div>
            <div class="col-md-6 mb-4">
              <label for="max_budget">Maximum budget</label>
              <input type="number" v-model="max_price" id="min_budget" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 label-col">
          <label class="text-white text-lg mt-2">Built up size </label>
        </div>
        <div class="col-md-9">
          <div class="row">
            <div class="col-md-6 mb-4">
              <label for="min_built_up_sqft"
                >Minimum built up size <small>(sqft)</small></label
              >
              <input
                type="number"
                v-model="min_built_up_sqft"
                id="min_built_up_sqft"
              />
            </div>
            <div class="col-md-6 mb-4">
              <label for="max_built_up_sqft"
                >Maximum built up size <small>(sqft)</small></label
              >
              <input
                type="number"
                v-model="max_built_up_sqft"
                id="max_built_up_sqft"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 label-col">
          <label class="text-white text-lg mt-2">Land size </label>
        </div>
        <div class="col-md-9">
          <div class="row">
            <div class="col-md-6 mb-4">
              <label for="min_land_sqft"
                >Minimum land size <small>(sqft)</small></label
              >
              <input type="number" v-model="min_land_sqft" id="min_land_sqft" />
            </div>
            <div class="col-md-6 mb-4">
              <label for="max_land_sqft"
                >Maximum land size <small>(sqft)</small></label
              >
              <input type="number" v-model="max_land_sqft" id="max_land_sqft" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 label-col">
          <label class="text-white text-lg mt-2">Remark </label>
        </div>
        <div class="col-md-9 mb-4">
          <label for="remark">Let us know more about your requirement</label>
          <textarea rows="4" v-model="remark" id="remark"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-9">
          <input type="checkbox" v-model="accept_term" id="accept_term" required/>
          <label for="accept_term"
            >I agree to the terms & conditions and privacy policy of Shijie
            Property</label
          >
        </div>
      </div>
      <button type="submit" class="btn mx-0">
        <span v-if="!isloading"
          >Create Automated Property Matching</span
        >
        <span v-else>Loading...</span>
      </button>
      <p v-if="error != ''" class="text-danger">{{ error }}</p>
    </form>
  </div>
</template>

<script>
export default {
  name: "property-matching-form",
  props: ['with_signup'],
  data() {
    return {
      email: "",
      name: "",
      phone_number: "",
      password: "",
      property_matching_id: "",
      listing_type: "SALE",
      category: "RESIDENTIAL",
      property_sub_type: null,
      min_price: null,
      max_price: null,
      min_built_up_sqft: null,
      max_built_up_sqft: null,
      min_land_sqft: null,
      max_land_sqft: null,
      number_of_room: null,
      number_of_bathroom: null,
      number_of_car_park: null,
      remark: "",
      accept_term: false,
      step: 1,
      error: "",
      isloading: false,
      states: [],
      areas: [],
      arealoaded: true,
      cur_state: "",
      selected_areas: [],
    };
  },
  watch: {
    cur_state: function (val) {
      this.getAreas(val, this.step);
    },
  },
  mounted() {
    this.getStates();
    if(!this.with_signup) {
      this.getPropertyMatchings();
    }
  },
  methods: {
    getPropertyMatchings: function () {
      let vm = this;
      vm.isloading = true;
      this.$http
        .get(`/api/v1/user/property_matchings`)
        .then((response) => {
          const rows = response.data.property_matchings;
          if (rows.length > 0) {
            const row = rows[0];
            vm.property_matching_id = rows[0].id;
            vm.category = row.category;
            vm.listing_type = row.listing_type;
            if (row.property_type_group == "HIGHRISE") {
              vm.property_sub_type = "Highrise";
            } else if (row.property_type_subtype == "TERRACE") {
              vm.property_sub_type = "Terrace";
            } else if (row.property_type_subtype == "SEMI DETACHED") {
              vm.property_sub_type = "Semi Detached";
            } else if (row.property_type_subtype == "DETACHED") {
              vm.property_sub_type = "Detached";
            }

            vm.min_land_sqft = row.minimum_land_area_tsqft;
            vm.max_land_sqft = row.maximum_land_area_tsqft;
            vm.min_built_up_sqft = row.minimum_built_up_area_tsqft;
            vm.max_built_up_sqft = row.maximum_built_up_area_tsqft;
            vm.min_price = row.minimum_price;
            vm.max_price = row.maximum_price;
            vm.remark = row.remark;
            vm.selected_areas = row.areas;
          }
          vm.isloading = false;
        })
        .catch((error) => {
          console.log(error);
          vm.isloading = false;
        });
    },
    submit(e) {
      e.preventDefault();
      if(!this.with_signup) {
        this.savePropertyMatching();
      }
      else {
        this.signup();
      }
    },
    savePropertyMatching(isSignup = false) {
      if (!this.isloading) {
        this.isloading = true;
        var formData = {
          category: this.category,
          listing_type: this.listing_type,
          minimum_land_area_tsqft: this.min_land_sqft,
          maximum_land_area_tsqft: this.max_land_sqft,
          minimum_built_up_area_tsqft: this.min_built_up_sqft,
          maximum_built_up_area_tsqft: this.max_built_up_sqft,
          minimum_price: this.min_price,
          maximum_price: this.max_price,
          remark: this.remark,
        };

        if (this.selected_areas.length > 0 || this.property_matching_id != "") {
          formData.areas = this.selected_areas;
        }
        if (this.property_sub_type == "Highrise") {
          formData.property_type_group = "HIGHRISE";
          formData.property_type_subtype = "";
        } else if (this.property_sub_type != null) {
          formData.property_type_group = "LANDED";
          formData.property_type_subtype = this.property_sub_type.toUpperCase();
        }
        this.$http[this.property_matching_id != "" ? "put" : "post"](
          `/api/v1/user/property_matchings${
            this.property_matching_id ? `/${this.property_matching_id}` : ""
          }`,
          {
            property_matching: formData,
          }
        )
          .then((res) => {
            this.$toast.success("Property wanted save successful", {
              position: "top-right",
            });
            this.isloading = false;
            if(isSignup) {
              setTimeout(() => {
                window.location.href = "/";
              }, 2000);
            }
          })
          .catch((e) => {
            this.isloading = false;
            this.error =
              "We're sorry, but something went wrong. Please try again later";
          });
      }
    },
    signup() {
      let vm = this;
      if (!this.isloading) {
        this.isloading = true;
        this.$http.post(
          `/api/v1/user/sign_up`,
          {
            user: {
              name: this.name,
              email: this.email,
              mobile_number: this.phone_number,
              password: this.password
            },
          }
        )
          .then(() => {
            console.log('success signup');
            vm.isloading = false;
            vm.savePropertyMatching(true);
          })
          .catch((e) => {
            vm.isloading = false;
            vm.error =
              "Email has already been taken ";
          });
      }
    },
    updateSelectedArea: function (val) {
      if(this.selected_areas.includes(val)) {
        const index = this.selected_areas.indexOf(val);
        console.log(index);
        if (index > -1) { // only splice array when item is found
          this.selected_areas.splice(index, 1); // 2nd parameter means remove one item only
        }
      }
      else {
        this.selected_areas.push(val)
      }
    },
    getStates: function () {
      let vm = this;
      this.$http
        .get("/streets/states")
        .then((response) => {
          vm.states = response.data.data.sort();
        })
        .catch((error) => {
          vm.states = [];
          console.log(error);
        });
    },
    getAreas: function (state, bool) {
      let vm = this;
      vm.arealoaded = false;
      this.$http
        .get("/streets/areas?state=" + state)
        .then((response) => {
          vm.areas = response.data.data.sort();
          if (bool) {
            vm.step = 2;
          } else {
            vm.step = 1;
          }
          vm.arealoaded = true;
        })
        .catch((error) => {
          vm.areas = [];
          console.log(error);
          vm.arealoaded = true;
        });
    },
  },
};
</script>


<style scoped>
.text-lg {
  font-size: 16px;
}
.header-wrapper {
  padding: 5px 20px;
  margin-bottom: 2.5rem;
}
.checkbox-label {
  background: rgb(140 140 140 / 10%) !important;
  padding: 0.65rem;
  margin: 0;
  margin-bottom: 1.5rem !important;
}
.checkbox-label input {
  display: none;
}
.checkbox-label.active {
  background: rgba(216, 0, 0, 0.1) !important;
  color: #d80000;
  padding: 0.65rem;
}
.extra-space {
  margin-bottom: 1.5rem;
}
.label-col {
  text-align: right;
}
.filter-location {
  border-radius: 5px;
  padding: 1rem;
  color: #afafaf;
}
.text-required {
  color: #d80000;
  display: inline-block;
  margin-left: 2px;
}
.contact-select {
  display: none;
}
@media screen and (max-width: 991px) {
  .filter-location {
    background: #1c1c1c;
  }
  .checkbox-label {
    display: none;
    margin-bottom: 0 !important;
  }
  .label-col {
    text-align: left;
  }
  .contact-select {
    display: block;
  }
}
.action-bar {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #515151;
  align-items: center;
}
.confirm-btn {
  padding: 0.5rem 1rem;
  margin-right: 0.5rem;
  color: #fff;
  background: #D80000;
  border-radius: 4px;
}
</style>